/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useRef, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

// NewUser page components
import UserInfo from "views/users/new-user/components/UserInfo";

// NewUser layout schemas for form and form feilds
import validations from "views/users/new-user/schemas/validations";
import form from "views/users/new-user/schemas/form";
import initialValues from "views/users/new-user/schemas/initialValues";

import { postData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

// sweetalert2 components
import Swal from "sweetalert2";

function getSteps() {
  return ["User Info"];
}

function NewUser({ signalCloseModal, id, checkToClose }) {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { formId, formField } = form;
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const ref = useRef(null);

  if (id) {
    initData();
  }

  function initData() {
    // initialValues.firstname = "charchalos";
    // initialValues.lastname = "marinos";
    // initialValues.username = "marinos";
    // initialValues.email = "marinos.charchalos@gmail.com";
    // initialValues.platforms = "1";
  }

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  
  const submitForm = async (values, actions) => {
    await sleep(1000);

    let setUsersEndpoint = `/api/v1/users/`;

    let objSent = { ...values };
    delete objSent.repeatPassword;

    let userPermissions = [...objSent.permissions];

    delete objSent.permissions;

    Swal.fire({
      title: "We proccess your request! ",
      html: "Please Wait a few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();

        let response = await postData(setUsersEndpoint, objSent, {
          Authorization: getAuthorizationHeader(),
        });

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            let userId = response.data.id;
            const postPermissionsEndpoint = `/api/v1/users/${userId}/permissions`;
            let permissions = userPermissions.map((item) => {
              return { id: item.id };
            });
            const setPermissionsResponse = await postData(postPermissionsEndpoint, permissions, {
              Authorization: getAuthorizationHeader(),
            });

            if (setPermissionsResponse.status === 200) {
              Swal.clickConfirm();
            }
          } else {
            Swal.clickDeny();
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.isConfirmed) {
        Swal.fire("User created!", `User ${objSent.username} Created sucessfull`, "success");
        signalCloseModal(true, null);

        actions.setSubmitting(false);
        actions.resetForm();
      }
      if (result.isDenied) {
        Swal.fire(
          "Error!",
          `Something goes wrong on User ${objSent.username} creation. Please try again later.`,
          "error"
        );
        signalCloseModal(false, null);

        actions.setSubmitting(false);
        actions.resetForm();
      }
    });

    return;

    // let setUsersEndpoint = `/api/v1/users/`;

    // let objSent = { ...values };
    // delete objSent.repeatPassword;
    // //delete objSent.roles;

    // let response = await postData(setUsersEndpoint, objSent, {
    //   Authorization: getAuthorizationHeader(),
    // });

    // if (response) {
    //   signalCloseModal(false, null);

    //   actions.setSubmitting(false);
    // }
  };

  const handleSubmit = (values, actions) => {
    submitForm(values, actions);
  };

  const handleCancelCreation = () => {
    let cancelData = false;
    for (const key in ref.current.values) {
      if (Object.hasOwnProperty.call(ref.current.values, key)) {
        const element = ref.current.values[key];
        if (element != "") {
          cancelData = true;
          break;
        }
      }
    }
    if (cancelData) {
      Swal.fire({
        title: `Cancel User Creation?`,
        html: `You are going to lose some data while Creating User. <br />
                  Are you sure?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          signalCloseModal(false, false);
        } else {
          signalCloseModal(false, cancelData);
        }
      });
    } else {
      signalCloseModal(false, cancelData);
    }
  };

  useEffect(() => {
    if (checkToClose) handleCancelCreation();
  }, [checkToClose]);

  return (
    <Grid container justifyContent="center" sx={{ height: "100%" }}>
      <Grid item sx={{ height: "100%", width: "100%" }}>
        <Formik
          innerRef={ref}
          initialValues={initialValues}
          validationSchema={currentValidation}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, isSubmitting }) => (
            <Form id={formId} autoComplete="off">
              <Card sx={{ height: "100%" }}>
                <SoftBox p={2}>
                  <SoftBox>
                    <UserInfo
                      formData={{
                        values,
                        touched,
                        formField,
                        errors,
                      }}
                    />
                  </SoftBox>
                  <SoftBox>
                    <Grid container justifyContent="right">
                      <Grid item>
                        <SoftButton variant="outlined" color="info" onClick={handleCancelCreation}>
                          Cancel
                        </SoftButton>
                      </Grid>
                      <Grid item>
                        <SoftButton type="submit" variant="gradient" color="dark">
                          save
                        </SoftButton>
                      </Grid>
                    </Grid>
                  </SoftBox>
                </SoftBox>
              </Card>
            </Form>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
}

NewUser.propTypes = {
  signalCloseModal: PropTypes.func,
  id: PropTypes.number,
  checkToClose: PropTypes.bool,
};
export default NewUser;
